import addSetEntry from './_addSetEntry';
import arrayReduce from './_arrayReduce';
import setToArray from './_setToArray';

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

export default cloneSet;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_cloneSet.js
// module id = null
// module chunks = 